<template>
    <label class="input-wrapper__title">{{ trans('Choose a payment method') }}</label>
    <Loading v-if="loading"/>

    <div id="payment" class="order-page__select-options" >
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('cash')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method" id="cash" name="order[payment_method]" class="radio-button__input" type="radio"
                           value="cash">
                    <label @click.prevent="setMethod('cash')" for="cash" class="radio-button__label"> </label>
                </div>
                <span class="radio-button__title">{{ trans('Payment upon receipt') }}</span>
            </div>
        </div>
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('cloud_payments')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method" id="cloud_payments" name="order[payment_method]" class="radio-button__input"
                           type="radio" value="cloud_payments">
                    <label @click.prevent="setMethod('cloud_payments')" for="cloud_payments" class="radio-button__label"> </label>
                </div>
                <span  class="radio-button__title">{{ trans('By bank card online') }}</span>
            </div>
            <div v-if="cloudPaymentDiscMessShow" class="delivery-method__info">
                <span class="order-page__select-option__description text-error">{{ trans("If you pay using this method, you get a discount") }} {{this.$store.state.settings.sale_payment}} %</span>
            </div>
        </div>
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('cloud_payments_parts')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method" id="cloud_payments_parts" name="order[payment_method]" class="radio-button__input"
                           type="radio" value="cloud_payments_parts">
                    <label @click.prevent="setMethod('cloud_payments_parts')" for="cloud_payments_parts" class="radio-button__label"> </label>
                </div>
                <span class="radio-button__title">Предоплата по карте 30% и 70% при получении</span>
            </div>
            <div v-if="cloudPaymentDiscMessShow" class="delivery-method__info">
                <span class="order-page__select-option__description text-error">{{ trans("If you pay using this method, you get a discount") }} {{this.$store.state.settings.sale_payment}} %</span>
            </div>
        </div>
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('dolyame')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method" id="dolyame" name="order[payment_method]" class="radio-button__input"
                           type="radio" value="dolyame">
                    <label @click.prevent="setMethod('dolyame')" for="dolyame" class="radio-button__label"> </label>
                </div>
                <span class="radio-button__title">{{ trans("Using the 'Shares' service") }}</span>
            </div>
            <div class="delivery-method__info">
                <span class="order-page__select-option__description">{{ trans("In equal parts with an interval of 2 weeks") }}</span>
            </div>
        </div>
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('yandex_split')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method"
                           id="yandex_split"
                           name="order[payment_method]"
                           class="radio-button__input"
                           type="radio"
                           value="yandex_split">
                    <label @click.prevent="setMethod('yandex_split')" for="yandex_split" class="radio-button__label"> </label>
                </div>
                <span class="radio-button__title">{{ trans("Using the 'Split' service") }}</span>
            </div>
            <div class="delivery-method__info">
                <span class="order-page__select-option__description">{{ trans("In equal parts with an interval of 2 weeks") }}</span>
            </div>
        </div>
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('paypal')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method" id="paypal" name="order[payment_method]" class="radio-button__input"
                           type="radio" value="paypal">
                    <label @click.prevent="setMethod('paypal')" for="paypal" class="radio-button__label"> </label>
                </div>
                <span class="radio-button__title">PayPal</span>
            </div>
            <div class="delivery-method__info">
                <span class="order-page__select-option__description"></span>
            </div>
        </div>
        <div class="order-page__select-option order-page__select-option_active" v-if="paymentMethods.includes('stripe')">
            <div class="radio-button">
                <div style="position: relative;">
                    <input v-model="method" id="stripe" name="order[payment_method]" class="radio-button__input"
                           type="radio" value="stripe">
                    <label @click.prevent="setMethod('stripe')" for="stripe" class="radio-button__label"> </label>
                </div>
                <span class="radio-button__title">Debit/credit card</span>
            </div>
            <div class="delivery-method__info">
                <span class="order-page__select-option__description"></span>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/loading.vue'

export default {
    name: "payments",
    props: {
        paymentMethods: Array,
        defMethod: String
    },
    components: {
        Loading
    },
    data() {
        return {
            loading: false,
            method: null,
        }
    },
    methods: {
        setMethod(method) {
            this.method = method
        },
    },
    computed: {
        cloudPaymentDiscMessShow() {
            return this.$store.state.settings.sale_payment && !this.$parent.isSecretCardExists && (!this.$parent.promo_cond.payment_method || !this.$parent.promo_cond.payment_method.includes('cloud_payments'))
        },
    },
    mounted() {
        this.method = this.defMethod
    },
    watch:{
        method(newVal, oldVal) {
            if (newVal === oldVal) return;
            this.$parent.paymentMethod = this.method
        },
        onlyCloud() {
            if (this.$store.state.settings.site_id == 1) {
                if (this.method != 'cloud_payments' && this.method != 'cloud_payments_parts') {
                    this.method = 'cloud_payments'
                }
            }
        },
        '$parent.promo_cond': {
            handler(newVal) {
                if (newVal.payment_method && !newVal.payment_method.includes(this.method)) {
                    this.method = newVal.payment_method[0]
                }
            }
        },
        defMethod(newVal, oldVal) {
            if (newVal === oldVal || newVal === this.method) return;
            this.method = this.defMethod
        }
    }
}
</script>

<style scoped>

</style>
